import Zellauslegung from './Zellauslegung';
export default Zellauslegung;
